// Lib
import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Components
import Button from '../Button';

// Constants
import { EMPTY_CART } from '../../constants/cart';

// Styles
import { useStyles } from './EmptyCartStyles';

const CartLayout = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const onClick = useCallback(() => navigate('/materials'), [navigate]);

  return (
    <div className={classes.root}>
      <Typography className={classes.message} variant="h1" textAlign="center">
        {EMPTY_CART}
      </Typography>
      <Button onClick={onClick} className={classes.button}>
        Go To Materials
      </Button>
    </div>
  );
};

export default CartLayout;
